

export const MainLayout = ({children}) => {
  return (
    <main>
        {children}
      </main>
  )
}
